<template>
  <div id="" class="mainDiv">
    <el-row type="flex" justify="start" align="middle">
      <el-col :span="10" style="margin-left: 10px">
        <el-button size="small" type="primary" @click="goBack">返回</el-button>
      </el-col>
    </el-row>
    <h2>签退二维码</h2>
    <img class="qrcodeimg" :src="qrcodeimg" alt="">
    <p class="p">签退人数：<span style="color: #0099FF;">{{signOutCount}}/{{total}}</span></p>
  </div>
</template>

<script>
import * as api from "@/api/attendance/pc";
export default {
  name: 'GongzhonghaoQrcode',
  data () {
    return {
      qrcodeimg:'',
      total:'',
      signOutCount:'',
      timer:'',
      timer2:'',
    }
  },
  methods: {
    getQrCode(){
      let that=this;
      let reqdata={
        courseId:this.$route.query.courseId,
        actionType:'2',
        type:2
      }
      api.getQrCode(reqdata).then(function(res){
        if(res.data.code=='100000'){
          that.qrcodeimg=res.data.data.url
        }
      })
      api.getSignOutRecordCount(reqdata).then(function(res){
        if(res.data.code=='100000'){
          that.total=res.data.data.total
          that.signOutCount=res.data.data.signOutCount
          // that.qrcodeimg=res.data.data.url
        }
      })
    },

    getQrCode2(){
      let that=this;
      let reqdata={
        courseId:this.$route.query.courseId,
        actionType:'2',
        type:2
      }
      api.getQrCode(reqdata).then(function(res){
        if(res.data.code=='100000'){
          that.qrcodeimg=res.data.data.url
        }
      })
    },


    getSignOutRecordCount(){
      let that=this;
      let reqdata={
        courseId:this.$route.query.courseId,
        actionType:'2',
        type:2
      }
      api.getSignOutRecordCount(reqdata).then(function(res){
        if(res.data.code=='100000'){
          that.total=res.data.data.total
          that.signOutCount=res.data.data.signOutCount
          // that.qrcodeimg=res.data.data.url
        }
      })
    },

    // tab切换
    handleClick () {
      this.pageObj.page = 1
      // this.getList()
    },
    goBack(){
      window.history.go(-1);
    }

  },
  created () {
    this.getQrCode()
    this.timer = setInterval(this.getSignOutRecordCount,1000*10)
    this.timer2 = setInterval(this.getQrCode2,1000*10)
  },
  computed: {
    getUId () {
      return localStorage.getItem('uid') 
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.timer2)
  }
}
</script>

<style lang="scss" scoped>
.qrcodeimg{
  width: 40%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
h2{
  text-align: center;
}
.p{
  text-align: center;
}
</style>
